import { axiosInstance } from "..";
import axios from "axios";

//Function to get all the users
export const manageApi = async() => {
    const response = await axiosInstance.get("api/getAllUsers");
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

//Function to update the role of a user
export const updateRoleApi = async (id: number, role:string) => {
    const response = await axios.post("api/updateUserRole", {
        user_id:id,role_update:role
    });
    return response;
}
